import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FaSearch, FaTimes } from 'react-icons/fa';
import './SearchBar.css';

const SearchBar = ({ 
  value, 
  onChange, 
  onClear, 
  placeholder = "Search...",
  className = "",
  showSearchIcon = true,
  showClearButton = true,
  disabled = false,
  size = "md"
}) => {
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <div className={`custom-search-bar w-100 ${className}`}>
      <div className="position-relative w-100">
        <Form.Control
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          className="ps-5 pe-4"
          style={{
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            padding: '12px 16px 12px 44px',
            fontSize: '14px',
            color: '#495057',
            boxShadow: 'none',
            transition: 'all 0.2s ease'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#007bff';
            e.target.style.backgroundColor = '#ffffff';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e9ecef';
            e.target.style.backgroundColor = '#f8f9fa';
          }}
        />
        {showSearchIcon && (
          <div 
            className="position-absolute top-50 translate-middle-y search-icon"
            style={{
              left: '14px'
            }}
          >
            <FaSearch size={16} />
          </div>
        )}
        {showClearButton && value && (
          <Button
            variant="link"
            onClick={onClear}
            className="position-absolute top-50 translate-middle-y p-0 border-0 clear-button"
            style={{
              right: '12px',
              color: '#6c757d',
              backgroundColor: 'transparent',
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Clear search"
          >
            <FaTimes size={14} />
          </Button>
        )}
      </div>
      
      {/* Optional: Search suggestions or filters could be added here */}
    </div>
  );
};

// Higher-order component for search highlighting
export const highlightSearchTerm = (text, searchTerm) => {
  if (!searchTerm || !text) return text;
  
  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);
  
  return parts.map((part, index) =>
    regex.test(part) ? (
      <mark key={index} style={{ backgroundColor: '#fff3cd', padding: '0.1em 0.2em' }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export default SearchBar;
